import { SearcherNameToId } from "../../../../../helpers/common/searchers/constants.js";
export const getTransformedPropsIfNeededMobile = (props)=>{
    if (props?.config?.literals?.informationLabel) return props;
    const { items  } = props ?? {};
    const finalItems = items?.map((item)=>{
        const searcherName = item?.component?.name ?? item?.data?.Name;
        return {
            id: SearcherNameToId[searcherName] ?? '',
            title: item?.navigation?.content ?? '',
            redirect: false,
            ajaxComponentData: item?.data,
            searcher: item?.component?.data
        };
    });
    return {
        ...props,
        items: finalItems ?? []
    };
};

//# sourceMappingURL=model.js.map